// eslint-disable-next-line max-classes-per-file
import moment from 'moment';
import BaseType from './BaseType';

export class AttendanceMap {
  booked: number[] = [];

  checkedIn: number[] = [];
}

export default class Session extends BaseType {
  id = '';

  eventId = 0;

  startsAt: moment.Moment = moment();

  endsAt: moment.Moment = moment();

  clientIds: number[] = [];

  staffIds: number[] = [];

  resourceIds: number[] = [];

  registrationIds: string[] = [];

  scheduleId = 0;

  status = '';

  attendanceMap: AttendanceMap = {
    booked: [],
    checkedIn: [],
  } as AttendanceMap;

  // base class requires.  this is a future API thing, and will be used for caching
  createdAt = moment();

  updatedAt = moment();
}
